import React from "react";
import { Alert } from "@mui/material";

const FetchProgressAlert = ({ visible, progressCount }) => {
  if (!visible) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <strong>Processing in background:</strong> The function should take about 3-5 minutes to complete. 
      Progress: {progressCount} records collected so far. Please wait...
    </Alert>
  );
};

export default FetchProgressAlert;
